const locale = {
	HOME:'Home',
	MAP:'Map',
	DASHBOARD: 'Dashboard',
	ADDMEMBER: 'Members',
	ADDPROJECT: 'Projects',
	PROJECTS: 'Projects',
	MAPPING: 'Mapping',
	RECYCLE: 'Recycle',
	INITIALIZATION: 'Initialization',
	MULTIPLE_COMPANIES:'Companies',
	DEVICESETTINGS: 'Device Settings',
	CONNECT: 'Connect',
	LIVESTREAM: 'Live Stream',
	DOWNLOADSTREAM: 'Download Stream',
	SWITCH_TO_USER: 'Switch to User',
	MIX_CALENDAR: 'Mix Calendar',
	LIVE_STREAM: 'Live Stream',
	DOWNLOAD_STREAM: 'Download Stream',
	CONTACT: 'Contact',
	CCTV_MAP: 'CCTV Map',
	CCTV: 'CCTV',
	SAFETY: 'Safety',
	BUILDEE: 'Buildee',
	GREEN_SITE: 'Green Site',
	RISK_PREDICTION: 'Risk Prediction',
	IOT2D: 'IOT(2D)',
	IOT3D: 'IOT(3D)',
};

export default locale;